import React from "react";

export default function DashboardToggles(props) {

    const { filterLabel,
        sortLabel,
        viewLabel,
        clearAllFiltersLabel,
        itemsPerPage,
        isLoading,
        handleDashboardCollapse,
        onClearAllFilters,
        filters    } = props;

    return (
        !isLoading ?
            filters && filters.length > 0 ?
            <div className="product-list-filters-triggers">
                <a href="#product-filters" onClick={(e) => handleDashboardCollapse(e.target.getAttribute("href"))}>
                    {filterLabel}
                </a>
                <a href="#product-filters-clear" onClick={onClearAllFilters}>
                    {clearAllFiltersLabel}
                </a>
                <a href="#sort-select" onClick={(e) => handleDashboardCollapse(e.target.getAttribute("href"))}>
                    {sortLabel}
                </a>
                <a href="#viewing-select" onClick={(e) => handleDashboardCollapse(e.target.getAttribute("href"))}>
                    {`${viewLabel} ${itemsPerPage}`}
                </a>
            </div>
            :
            <div className="product-list-filters-triggers">
                <a href="#sort-select" onClick={(e) => handleDashboardCollapse(e.target.getAttribute("href"))}>
                    {sortLabel}
                </a>
                <a href="#viewing-select" onClick={(e) => handleDashboardCollapse(e.target.getAttribute("href"))}>
                    {`${viewLabel} ${itemsPerPage}`}
                </a>
            </div>
            :
            null
    );
}